/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateExportLogDataStatusSchema = z.enum(['completed', 'failed'])

export type CandidateExportLogDataStatusSchema = z.infer<typeof candidateExportLogDataStatusSchema>
